import React, { useEffect, useState } from "react";
import FloorplanSelectControl from "./FloorplanSelectControl";
import FloorplanOverlay from "./FloorplanOverlay";
import api from "../../api";
import { useMap } from "@vis.gl/react-google-maps";
import useCommonMap from "../../hooks/useCommonMap";
import useAuth from "../../hooks/useAuth";

const CommonMapFloorplans = ({
  mode,
  // onSelectedFloorplanChanged,
  onSelectedGeometryChanged,
  data,
  geofenceFloorplan = null,
  children,
}) => {
  // const [selectedFloorplan, setSelectedFloorplan] = useState(null);
  // const [floorplanImage, setFloorplanImage] = useState(null);
  // const map = useMap();
  const { user } = useAuth();

  const commonMap = useCommonMap();
  const {
    selectedFloorplan,
    setSelectedFloorplan,
    floorplanImage,
    setFloorplanImage,
    current,
    setCurrent,
  } = commonMap;

  useEffect(() => {
    if (selectedFloorplan) {
      getFloorplanImage(selectedFloorplan.id);
    } else {
      setFloorplanImage(null);
    }

    return () => {
      setFloorplanImage(null);
      // map && map.overlayMapTypes.clear();
      // map && map.data.forEach((feature) => map.data.remove(feature));
      // map && map.setHeading(0);
      // map && map.data.setStyle(null);
      // map && map.data.setMap(null);
      // map && map.close();
      // map && map.unbindAll();
      // map && map = null;
    };
  }, [selectedFloorplan]);

  const getFloorplanImage = (id) => {
    api
      .get(`files/floorplans/${id}`, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        let blob = new Blob([res.data], { type: "img/jpeg" });
        let url = (window.URL || window.webkitURL).createObjectURL(blob);
        setFloorplanImage(url);
      })
      .catch(() => setFloorplanImage(null));
  };

  // const handleSelect = (selectedFloorplan) => {
  //   setSelectedFloorplan(selectedFloorplan);
  //   onSelectedFloorplanChanged && onSelectedFloorplanChanged(selectedFloorplan);
  //   // getFloorplanImage(selectedFloorplan.id);
  // };

  if (
    mode.startsWith("view") === false &&
    mode !== "edit" &&
    mode !== "geofence" &&
    mode !== "readerview"
  ) {
    return <React.Fragment>{children}</React.Fragment>;
  } else {
    return (
      <React.Fragment>
        {!(mode === "viewMarkers" && !selectedFloorplan) && (
          <FloorplanSelectControl
            showDefault={mode !== "geofence" && mode !== "readerview"}
            showMap={
              (mode === "geofence" || mode === "readerview") && user.showMap
            }
            asset={current?.id ?? null}
            // onSelect={handleSelect}
            right={mode === "view" || mode === "readerview"}
            hideSitePlans={mode === "geofence"}
            defaultId={geofenceFloorplan ? geofenceFloorplan.id : null}
          />
        )}
        <FloorplanOverlay
          mode={mode}
          img={floorplanImage}
          curFloor={selectedFloorplan}
          setSelectedGeometry={(g) => {
            onSelectedGeometryChanged && onSelectedGeometryChanged(g);
          }}
          rotate={selectedFloorplan?.rotation || 0}
          // selectedGeometry={selectedGeometry}
          // setSelectedGeometry={setSelectedGeometry}
          setPosition={null}
          setPosition1={null}
        />
        {children}
      </React.Fragment>
    );
  }
};

export default CommonMapFloorplans;
